
import { RadioButton } from 'element-ui'

export default {
  extends: RadioButton,
}
